import { RECOMMENDED_RESOURCES } from "@/lib/onboarding/resources-map";
import { useOnboarding } from "@/features/profile/hooks";

const DATA = [
  {
    id: 1,
    thumbnail:
      "https://storage.googleapis.com/iaeqpsxmmk/video_thumbnail_1.png",
    title: "What is AssessioAI",
    type: "video",
    url: "https://storage.googleapis.com/iaeqpsxmmk/Wisniomp4.mp4",
  },
  {
    id: 2,
    thumbnail:
      "https://storage.googleapis.com/iaeqpsxmmk/learning_center_2.png",
    title: "How to get started with AssessioAI",
    type: "article",
    url: "https://support.wisnio.com/en/collections/2701407-how-to-get-started-on-wisnio",
  },
  {
    id: 3,
    thumbnail:
      "https://storage.googleapis.com/iaeqpsxmmk/learning_center_3.png",
    title: "AssessioAI tools overview",
    type: "article",
    url: "https://support.assessio.ai/en/collections/2708385-5-leadership-assessment-and-team-development-tools",
  },
];
export const useLearningCenter = () => {
  const { onboardingPersona } = useOnboarding();

  const learningCenterData = DATA;

  const resources = RECOMMENDED_RESOURCES.filter((resource) =>
    resource.personas.includes(onboardingPersona)
  );

  return {
    learningCenterData,
    resources,
  };
};
